import { Component, OnInit } from '@angular/core';
import {IntegrationService} from "@cx-services/integration.service";
import { HeaderComponent } from '../header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'cx-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: true,
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class LayoutComponent implements OnInit {

  constructor(
    private iS: IntegrationService
  ) { }

  ngOnInit(): void {
    this.iS.initSource()
  }

}
